import React, { Component } from 'react';
import { DbLogoText, DbLogo } from '../../../components/common/icons';
import { Office, Email } from '@dbk/ui-icons';
import Dropdown from '@dbk/ui-dropdowns';
import { PALETTE, REGION, KEY_CODE } from '../../../constants';
import languageData from '../../../data/language-list.json';
import { createContainer } from '@dbk-legacy/muster/react';
import { find } from 'lodash';
import './login.css';
class Header extends Component {

    constructor(props) {
        super(props);
      }

    state = {
        hoveredElement: null,
      }

    convertToDropDown = values => {
        if (values && values.length) {
            if (values.length >= 1) {
                return values.map(e => ({
                    label: e.language,
                    value: e.key,
                    code: e.langCode
                }));
            }

            return values.map(e => ({
                value: e.key,
                code: e.langCode
            }));
        }
        return [];
    }

    pressedConfirm = key => {
        const languageObj = find(languageData.languageList, { key })
        const {
            languages: { destLanguageCode, saveLanguageAtLogin }

        } = this.props;
        document.documentElement.setAttribute('lang', languageObj.langCode);
        const destLang = destLanguageCode.includes(key.toLowerCase());
        if (!destLang) {
            saveLanguageAtLogin({ languageObj });
        }
    };

    handleFaq = (e) => {
        if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
            this.props.changePage('/login-faq');
        }
    };

    handleContactUs = (e) => {
        if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
            this.props.changePage('/login-contact-us');
        }
    };

    handleMouseEnter=(element)=>{
        this.setState({hoveredElement:element});
        };
      
    handleMouseLeave=()=>{
        this.setState({hoveredElement:null});
    }

    render = () => {

        let languageListArray = [];
        const { i18n: { messages }, languages: { destLanguage }, app, config: { regionCode } } = this.props;

        languageListArray = languageData.languageList && this.convertToDropDown(languageData.languageList)
        const languageCH = destLanguage === "English" ? "English" : "Deustche";
        const languageAPAC = destLanguage === "English" ? "ZH" : "default";
        const languageSelected = regionCode === 'CH' ? languageCH : languageAPAC;

        return (
            <div className='login login-header'>
                <div>
                    <DbLogoText className="login__logo" />
                </div>
                <div className='login-header-content'>
                    <div className='cursor-pointer display-flex-row faq-title-container margin-right-40' aria-label={messages['app.login.accessibility.link.contactUs']} role='button' tabIndex={0} onKeyDown={(e) => this.handleContactUs(e)} onClick={() => this.handleContactUs()} onMouseEnter={()=> this.handleMouseEnter("contact-us")} onMouseLeave={()=>this.handleMouseLeave()}>
                        <Email height={32} width={32} color={this.state.hoveredElement === "contact-us" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive} className='margin-right-10'></Email>
                        <span  className={`${this.state.hoveredElement === "contact-us" ? "textHoverColor cursor-pointer" : "cursor-pointer"}`}  >{messages['app.login.contact.us']}</span>
                    </div>
                    <div className='cursor-pointer display-flex-row faq-title-container margin-right-40' aria-label={messages['app.login.faq']} role='button' tabIndex={0} onKeyDown={(e) => this.handleFaq(e)} onClick={() => this.handleFaq()} onMouseEnter={()=> this.handleMouseEnter("faq")} onMouseLeave={()=>this.handleMouseLeave()}>
                        <Office height={32} width={32} color={this.state.hoveredElement === "faq" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive} className='margin-right-10'></Office>
                        <div className={`${this.state.hoveredElement === "faq" ? "textHoverColor cursor-pointer" : "cursor-pointer"}`}>{messages['app.login.faq']}</div>
                    </div>
                    <div role="list" className="dropdown-style margin-right-40" aria-label={messages['app.accessibility.login.languageSelection']}>
                        <Dropdown
                            defaultLabel
                            name="languageSeletcor"
                            tabIndex={0}
                            className="login-lang-dropdown no-hover"
                            selected={languageSelected}
                            options={languageListArray}
                            size='small'
                            onChange={option => {
                                this.pressedConfirm(option)
                            }}
                        />
                    </div>
                    <DbLogo ></DbLogo>
                </div>
            </div>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        languages: {
            saveLanguageAtLogin: { $call: 'saveLanguageAtLogin' },
            getlanguages: { $call: 'getlanguages' },
            destLanguage: true,
            destLanguageCode: true,
        },
        config: {
            regionCode: true
        },
        changePage: { $call: 'ui.history.push' },
    },
})(Header);



